import { usePageMeta } from '../../lib/seo.tsx';

export default function ThankYou() {
  usePageMeta({
    title: 'Thank you!',
    description: 'Thank you for your submission.',
    pathname: '/thank-you',
    noIndex: true,
  });

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <h1 className="text-center text-4xl font-bold">
        Thank you for your submission!
      </h1>
    </div>
  );
}
